import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Delay showing banner slightly to not block initial render (improves LCP)
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Mobile-optimized Cookie Banner - Less intrusive bottom sheet style */}
      <div 
        className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-4 animate-slide-up" 
        data-testid="cookie-banner"
      >
        <div className="max-w-2xl mx-auto bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200/50 overflow-hidden">
          <div className="p-4 sm:p-5">
            {/* Compact header */}
            <div className="flex items-center justify-between gap-3 mb-3">
              <h3 className="text-base font-semibold text-gray-900">🍪 Cookies</h3>
              <button 
                onClick={acceptNecessary}
                className="p-1.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                aria-label="Close cookie banner"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            
            {/* Shorter text for mobile */}
            <p className="text-sm text-gray-600 mb-3 leading-relaxed">
              We use cookies to improve your experience.{' '}
              <a
                href="/cookie-policy"
                className="text-purple-600 hover:text-purple-700 font-medium underline-offset-2 hover:underline"
              >
                Learn more
              </a>
            </p>

            {/* Mobile-friendly button layout - larger tap targets */}
            <div className="flex gap-2">
              <button
                onClick={acceptAll}
                className="flex-1 px-4 py-2.5 rounded-full font-medium text-white text-sm animated-gradient-button min-h-[44px]"
                data-testid="cookie-accept-all"
              >
                Accept All
              </button>
              <button
                onClick={acceptNecessary}
                className="flex-1 px-4 py-2.5 rounded-full font-medium text-gray-700 text-sm bg-gray-100 hover:bg-gray-200 transition-colors min-h-[44px]"
                data-testid="cookie-accept-necessary"
              >
                Necessary Only
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
